<template>
  <div class="uniform">
    <div class="itemList">
      <van-swipe :height="300" ref="mySwipe" :initial-swipe="index" @change="onChange">
        <van-swipe-item v-for="(image, index) in images" :key="index" @click="onImgPreView">
          <img :src="image" style="max-width: 100%" />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ index + 1 }}/{{ images.length }}</div>
          <span v-if="dataDetail.is_bundles" class="bundleTag">套装</span>
        </template>
      </van-swipe>
      <div class="content">
        <div class="flex1 font18">
          <span class="colorRed fontWeight"><span class="font12">¥</span> {{ currentPrice }}</span
          ><span class="van-card__origin-price font12 color6" v-if="scribing_price != ''">¥ {{ scribing_price }}</span>
          <span class="font12 color6 ml-10" v-if="dataDetail.is_bundles">内含{{ getBundleNum() }}件商品</span>
        </div>
        <div class="color3 mt-15 font16 fontWeight">{{ dataDetail.title }}</div>
        <div class="color6 font13 mt-5">{{ dataDetail.intro }}</div>
        <van-divider />
        <div v-if="!dataDetail.is_bundles">
          <div class="categoryTitle">{{ $t("uniform.Color") }}</div>
          <van-row gutter="20">
            <span v-for="(list, key, index) in colorItem" :key="index">
              <span class="tagList" :class="key == colorNum ? 'currentTag' : ''" @click="colorClick(key)" v-if="!list.disabled">{{ list.title }}</span>
              <span class="tagList disabledTag" v-else>{{ list.title }}</span>
            </span>
          </van-row>
          <div class="categoryTitle">{{ $t("uniform.Size") }}</div>
          <van-row gutter="20">
            <span v-for="(list, key, index) in sizeItem" :key="index">
              <span class="tagList" :class="key == sizeNum ? 'currentTag' : ''" @click="sizeClick(key)" v-if="!list.disabled"
                >{{ list.title }} <span class="NoStock" v-if="currentStock <= 0 && key == sizeNum && dataDetail.presale == 0 && dataDetail.unlimited == 0 && colorNum != ''">{{ $t("uniform.Out_stock") }}</span><span class="presale" v-if="currentStock <= 0 && key == sizeNum && dataDetail.presale == 1">预售</span></span
              >
              <span class="tagList disabledTag" v-else>{{ list.title }}</span>
            </span>
          </van-row>
        </div>
        <div v-if="dataDetail.is_bundles">
          <div class="categoryTitle">套装尺码</div>
          <van-row gutter="20">
            <span v-for="(list, key, index) in sizeItem" :key="index">
              <span class="tagList" :class="key == sizeNum ? 'currentTag' : ''" @click="sizeClick(key)" v-if="!list.disabled"
                >{{ list.title }} </span
              >
              <span class="tagList disabledTag" v-else>{{ list.title }}</span>
            </span>
          </van-row>
          <div v-for="(lists, key) in dataDetail.attr.bundle_items" :key="key">
            <div class="flex alignStart mt-20 mb-5" v-if='dataDetail.bundleInfo[lists.pid]'>
              <img v-if="dataDetail.bundleInfo[lists.pid].img[dataDetail.bundleInfo[lists.pid].attr.color.item[lists.attr1]]" :src="dataDetail.bundleInfo[lists.pid].img[dataDetail.bundleInfo[lists.pid].attr.color.item[lists.attr1]][0]" alt="" class="img72" />
              <img v-else :src="dataDetail.bundleInfo[lists.pid].img.all[0]" alt="" class="img72" />
              <div class="flex1 align-items ml-10">
                <div class="flex align-items mt-5">
                  <div class="flex1 font14 color3 fontWeight">{{ lists.abb_title }}</div>
                  <span class="fontWeight color3"
                    ><span class="font12">¥ </span><span class="font14">{{ dataDetail.bundleInfo[lists.pid].unit_price }}</span>
                  </span>
                </div>
                <div class="mt-15">
                  <span class="font12 color6" >{{ dataDetail.bundleInfo[lists.pid].attr.color.item[lists.attr1] }} 
                    <span v-if="lists.sizeNum != ''"> / 
                      <span v-if='dataDetail.bundleInfo[lists.pid].attr_special.length==0'>{{ sizeItem[lists.sizeNum].title }}</span>
                      <span v-else-if="dataDetail.bundleInfo[lists.pid].attr_special.list">{{ dataDetail.bundleInfo[lists.pid].attr.size.item[dataDetail.bundleInfo[lists.pid].attr_special.list[lists.sizeNum]] }}</span>
                      <span v-else-if="dataDetail.bundleInfo[lists.pid].attr_special.only">{{ dataDetail.bundleInfo[lists.pid].attr.size.item[dataDetail.bundleInfo[lists.pid].attr_special.only] }}</span>

                    </span>
                  </span>
                  <span class="fr color6 font12 mt-4">x{{ lists.num }}</span>
                  <!-- <span class="font12 suitLabel"
                    ><span class="color6"></span><span class="color3">{{ dataDetail.bundleInfo[lists.pid].attr.color.item[lists.attr1] }}</span></span
                  >
                  <span class="font12 suitLabel ml-10" v-if="lists.sizeNum != ''" @click="lists.showSize = !lists.showSize"
                    ><span class="color6">尺码：</span><span class="color3">{{ sizeItem[lists.sizeNum].title }}</span>
                    <van-icon name="arrow-up" v-if="lists.showSize" class="color6 ml-5" /><van-icon name="arrow-down" v-if="!lists.showSize" class="color6 ml-5"
                  />
                  </span>
                  <span class="font12 colorWarning ml-5" v-if="lists.sizeNum != '' && lists.sizeNum != sizeNum"><van-icon name="warning-o" /> 注意核对</span>
                  <span class="fr color6 font12 mt-4">x{{ lists.num }}</span> -->
                </div>
              </div>
            </div>
            <van-row gutter="20" v-if="lists.showSize">
              <span v-for="(list, key, index) in sizeItem" :key="index"
                ><span class="tagList" :class="key == lists.sizeNum ? 'currentTag' : ''" @click="suitSizeClick(lists, key)" v-if="!list.disabled"
                  >{{ list.title }} <span class="NoStock" v-if="currentStock <= 0 && key == sizeNum">{{ $t("uniform.Out_stock") }}</span>
                </span>
                <span class="tagList disabledTag" v-else>{{ list.title }}</span>
              </span>
            </van-row>
          </div>
        </div>

        <div class="categoryTitle">
          <div class="van-sku__stepper-title">
            {{ $t("uniform.Quantity") }} <span class="font12 color9 ml-10" v-if="sizeNum != '' && colorNum != '' && !dataDetail.is_bundles && dataDetail.presale != 1 && dataDetail.unlimited != 1">{{ $t("uniform.Stock_Quantity") }}{{ currentStock >= 0 ? currentStock : 0  }}</span>
          </div>
          <div class="van-stepper van-sku__stepper" v-if="currentStock != 0 || dataDetail.unlimited == 1"><button type="button" class="van-stepper__minus" @click="reduceNum" :class="quantityNum == 1 ? 'van-stepper__minus--disabled' : ''"></button><input type="tel" v-model="quantityNum" class="van-stepper__input" /><button type="button" class="van-stepper__plus" @click="addNum" :class="dataDetail.unlimited == 1 ? '' : (quantityNum >= currentStock ? 'van-stepper__minus--disabled' : '')"></button></div>
          <div class="van-stepper van-sku__stepper" v-if="currentStock == 0 && dataDetail.unlimited != 1"><button type="button" class="van-stepper__minus van-stepper__minus--disabled"></button><input type="tel" v-model="quantityNum" class="van-stepper__input" /><button type="button" class="van-stepper__plus van-stepper__minus--disabled"></button></div>
        </div>
        <van-notice-bar class="noticeBto" v-if="currentStock <= 0  && dataDetail.presale == 1 && (sizeNum != '' && colorNum != '')" color="#666666" background="#F2F3F5" left-icon="info-o" text="预售商品一般需要等待 7 个工作日以上" />
        <van-goods-action v-if="currentStock <= 0  && dataDetail.unlimited == 0 && (sizeNum != '' && colorNum != '')"  class="p10">
          <van-goods-action-button color="#4D88D2" type="warning" :text="$t('uniform.Out_stock')" :loading="registerLoading" disabled />
        </van-goods-action>
        <van-goods-action v-else class="p10">
          <van-goods-action-button color="#4D88D2" type="warning" @click="addShop" :text="$t('uniform.Add_To_Cart')" />
          <van-goods-action-button color="#F5A429" type="danger" :text="$t('uniform.buy_Now')" :loading="showLoading" :disabled="showLoading" @click="buyNow" />
        </van-goods-action>
      </div>
    </div>
    <shopping :actionShow="actionShow" :shoppingData="shoppingData" @click="hideAction" :key="datekey" />
  </div>
</template>

<script>
import storage from "store";
import Vue from "vue";
import { CURRENT_CHILD, UNIFORM_SHOPPING } from "@/store/mutation-types";
import i18n from "../i18n";
import { productDetail, recordWant, cancelPay } from "@/api/uniform";
import { NoticeBar, ActionSheet, Empty, Toast, Icon, GoodsAction, GoodsActionIcon, GoodsActionButton, Sku, Divider, Swipe, SwipeItem, ImagePreview, Card } from "vant";
import Shopping from "@/components/shopping";
// import wx from "weixin-js-sdk";
import store from "../store";
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Divider);
Vue.use(Sku);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(SwipeItem);
Vue.use(Card);
export default {
  name: "lunch",
  components: {
    shopping: Shopping,
  },
  data() {
    return {
      show: false,
      quantityNum: 1,
      images: [],
      dataDetail: {},
      pid: "",
      actionShow: false,
      shoppingData: {},
      colorItem: {},
      sizeItem: {},
      colorNum: "",
      sizeNum: "",
      currentStock: null,
      infoList: {},
      child_id: "",
      showLoading: false,
      datekey: Date.now(),
      index: 0,
      currentPrice: 0,
      scribing_price: "",
      childData: {},
      registerLoading: false,
    };
  },
  beforeCreate() {
    // document.querySelector("body").setAttribute("style", "background-color:#fff;");
  },
  mounted() {
    let schoolType = store.getters.wxState || "ds";
    document.title = schoolType == "ds" ? this.$t("router.uniform") : this.$t("router.Purchase");
  },
  created() {
    this.childData = storage.get(CURRENT_CHILD + i18n.locale);
    this.child_id = this.childData.id;
    let shop = storage.get(UNIFORM_SHOPPING + "_" + this.childData.family_id) || { shopping: {}, order: [] };
    this.infoList = shop.shopping;
    this.pid = this.$route.params.id;
    this.getList();
  },
  methods: {
    getList() {
      productDetail({ pid: this.$route.params.id, child_id: this.child_id }).then((res) => {
        this.dataDetail = res.data;
        this.images = res.data.img;
        this.currentPrice = res.data.unit_price;
        this.scribing_price = res.data.scribing_price;

        this.colorItem = {};
        for (let key in this.dataDetail.attr.attr.color.item) {
          this.colorItem[key] = {
            disabled: false,
            title: this.dataDetail.attr.attr.color.item[key],
          };
        }
        this.sizeItem = {};
        for (let key in this.dataDetail.attr.attr.size.item) {
          this.sizeItem[key] = {
            disabled: false,
            title: this.dataDetail.attr.attr.size.item[key],
          };
        }
        if (this.dataDetail.is_bundles) {
          for (let i = 0; i < this.dataDetail.attr.bundle_items.length; i++) {
            Vue.set(this.dataDetail.attr.bundle_items[i], "sizeNum", "");
            Vue.set(this.dataDetail.attr.bundle_items[i], "showSize", false);
          }
          this.colorNum = 6;
        }
      });
    },
    onImgPreView() {
      // 点击轮播图时,通过数据拿到当前索引,根据当前索引创建图片预览,设置默认图片
      const that = this;
      ImagePreview({
        images: this.images, //点击后的图片。
        startPosition: this.index, //index默认为0，提供的起始位置
        onChange(i) {
          // 当图片预览切换时,根据切换后的索引,设置轮播图的位置
          that.$refs.mySwipe.swipeTo(i);
        },
      });
    },
    onChange(index) {
      this.index = index;
    },
    hideAction() {},
    colorClick(item) {
      if (item == this.colorNum) {
        this.colorNum = "";
        this.quantityNum = 1;
        this.currentPrice = this.dataDetail.unit_price;
        this.scribing_price = this.dataDetail.scribing_price;
        this.currentStock = null;
        for (let key in this.dataDetail.attr.attr.size.item) {
          this.sizeItem[key].disabled = false;
        }
        return;
      }
      this.colorNum = item;
      for (let key in this.dataDetail.attr.attr.size.item) {
        if (this.dataDetail.attr.sku[item][key]) {
          this.sizeItem[key].disabled = false;
        } else {
          this.sizeItem[key].disabled = true;
        }
      }
      if (this.sizeNum != "" && this.colorNum != "") {
        this.getStock();
      }
    },
    suitSizeClick(lists, key) {
      lists.sizeNum = key;
    },
    getBundleNum() {
      let num = 0;
      if (this.dataDetail.attr && this.dataDetail.attr.bundle_items) {
        this.dataDetail.attr.bundle_items.forEach((item) => {
          num += item.num;
        });
      }
      return num;
    },
    sizeClick(item) {
      if (item == this.sizeNum) {
        this.sizeNum = "";
        if (this.dataDetail.is_bundles && this.dataDetail.attr.bundle_items) {
          for (let i = 0; i < this.dataDetail.attr.bundle_items.length; i++) {
            this.dataDetail.attr.bundle_items[i].sizeNum = '';
          }
        }
        this.quantityNum = 1;
        this.currentPrice = this.dataDetail.unit_price;
        this.scribing_price = this.dataDetail.scribing_price;
        this.currentStock = null;
        for (let key in this.dataDetail.attr.sku) {
          this.colorItem[key].disabled = false;
        }
        return;
      }
      this.sizeNum = item;
      if (this.dataDetail.is_bundles && this.dataDetail.attr.bundle_items) {
        for (let i = 0; i < this.dataDetail.attr.bundle_items.length; i++) {
          this.dataDetail.attr.bundle_items[i].sizeNum = item;
        }
      }
      for (let key in this.dataDetail.attr.sku) {
        if (this.dataDetail.attr.sku[key][item]) {
          this.colorItem[key].disabled = false;
        } else {
          this.colorItem[key].disabled = true;
        }
      }
      if (this.sizeNum != "" && this.colorNum != "") {
        this.getStock();
      }
    },
    getStock() {
      this.quantityNum = 1;
      this.currentPrice = this.dataDetail.attr.sku[this.colorNum][this.sizeNum].price;
      this.scribing_price = this.dataDetail.attr.sku[this.colorNum][this.sizeNum].scribing_price;
      this.currentStock = this.dataDetail.attr.sku[this.colorNum][this.sizeNum].stock;
    },
    reduceNum() {
      if (this.quantityNum <= 1) {
        return;
      } 
      this.quantityNum = this.quantityNum - 1;
      
    },
    addNum() {
      if (this.dataDetail.unlimited == 1) {
        this.quantityNum = this.quantityNum + 1;
        return;
      }
      if (this.currentStock != 0 && this.quantityNum >= this.currentStock) {
        return;
      }
      this.quantityNum = this.quantityNum + 1;
    },
    addShop() {
      if (this.colorNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      if (this.sizeNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      let paid = this.dataDetail.attr.sku[this.colorNum][this.sizeNum].paid;
      if (this.dataDetail.is_bundles && this.dataDetail.attr.bundle_items) {
        if (!this.infoList[this.child_id]) {
          this.infoList[this.child_id] = {};
        }
        // let pidStr = paid;
        let bundleList = [];
        for (let i = 0; i < this.dataDetail.attr.bundle_items.length; i++) {
          let items = this.dataDetail.attr.bundle_items[i];
          let bundlePaid = '';
          let bundle = this.dataDetail.bundleInfo[items.pid];
          if (bundle.attr_special.length == 0) {
            bundlePaid = bundle.sku[items.attr1][items.sizeNum].paid;
          } else if (bundle.attr_special.list) {
            bundlePaid = bundle.sku[items.attr1][bundle.attr_special.list[items.sizeNum]].paid;
          } else if (bundle.attr_special.only) {
            bundlePaid = bundle.sku[items.attr1][bundle.attr_special.only].paid;
          }
          // pidStr += "_" + bundlePaid;
          bundleList.push({ id: items.id, paid: bundlePaid });
        }
        // 新结构：{ list: [{id, paid}, ...], num: quantity }
        if (this.infoList[this.child_id][paid] && this.infoList[this.child_id][paid].num) {
          this.infoList[this.child_id][paid].num += this.quantityNum;
        } else { 
          this.infoList[this.child_id][paid] = { list: bundleList, num: this.quantityNum };
        }
      } else {
        // 非套装：infoList[child_id][paid] = quantity
        if (this.infoList[this.child_id]) {
          if (this.infoList[this.child_id][paid]) {
            this.infoList[this.child_id][paid] = this.infoList[this.child_id][paid] + this.quantityNum;
          } else {
            this.infoList[this.child_id][paid] = this.quantityNum;
          }
        } else {
          this.infoList[this.child_id] = {};
          this.infoList[this.child_id][paid] = this.quantityNum;
        }
      }

      // if (this.infoList[this.child_id]) {
      //   if (this.infoList[this.child_id][paid]) {
      //     this.infoList[this.child_id][paid] = this.infoList[this.child_id][paid] + this.quantityNum;
      //   } else {
      //     this.infoList[this.child_id][paid] = this.quantityNum;
      //   }
      // } else {
      //   this.infoList[this.child_id] = {};
      //   this.infoList[this.child_id][paid] = this.quantityNum;
      // }
      
      let shop = {
        shopping: this.infoList,
        order: {},
      };
      storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
      this.quantityNum = 1;
      this.datekey = Date.now();
      Toast.success(this.$t("uniform.added_Cart"));
      this.show = false;
    },
    register() {
      if (this.colorNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      if (this.sizeNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      this.registerLoading = true;
      recordWant({ aid: this.dataDetail.attr.sku[this.colorNum][this.sizeNum].paid, child_id: this.child_id, num: this.quantityNum })
        .then((res) => {
          if (res.code == 0) {
            Toast.success(res.msg);
          }
          this.registerLoading = false;
        })
        .catch(() => {
          this.registerLoading = false;
        });
    },
    buyNow() {
      if (this.colorNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      if (this.sizeNum == "") {
        Toast(this.$t("uniform.select_specifications"));
        return;
      }
      let id = this.dataDetail.attr.sku[this.colorNum][this.sizeNum].paid;
      let product = {};
      product[this.child_id] = [];
      product[this.child_id].push({
        num: this.quantityNum,
        pid: this.pid,
        paid: id,
      });
      this.showLoading = true;
      let shop = storage.get(UNIFORM_SHOPPING + "_" + this.childData.family_id) || { shopping: {}, order: [] };
      // 构建要保存的订单项
      let orderItem = {
        cid: this.dataDetail.attr.cid,
        pid: this.dataDetail.attr.pid,
        is_bundles: this.dataDetail.is_bundles || false,
        paid: this.dataDetail.attr.sku[this.colorNum][this.sizeNum].paid,
        title: this.dataDetail.title,
        num: this.dataDetail.num,
        unit_price:  this.dataDetail.attr.sku[this.colorNum][this.sizeNum].price,
        scribing_price: this.dataDetail.scribing_price,
        status: 1,
        attr1: this.dataDetail.attr.attr.color.item[this.colorNum],
        attr2: this.dataDetail.attr.attr2 || this.sizeItem[this.sizeNum].title,
        img: this.dataDetail.attr.img.all[0],
        child_id: this.child_id,
        quantity: this.quantityNum,
        stock: this.quantityNum,
        check: true,
      };
      // 如果是套装商品，添加套装信息
      if (this.dataDetail.is_bundles) {
        orderItem.is_bundle_main = true;
        let pidStr = this.dataDetail.attr.paid;
        orderItem.bundle_items = [];
        for (let i = 0; i < this.dataDetail.attr.bundle_items.length; i++) {
          let items = this.dataDetail.attr.bundle_items[i];
          let bundlePaid=''
          let bundle =this.dataDetail.bundleInfo[items.pid]
          if(bundle.attr_special.length==0){
             bundlePaid = bundle.sku[items.attr1][items.sizeNum].paid;
          }else if(bundle.attr_special.list){
             bundlePaid = bundle.sku[items.attr1][bundle.attr_special.list[items.sizeNum]].paid;
          }else if(bundle.attr_special.only){
             bundlePaid = bundle.sku[items.attr1][bundle.attr_special.only].paid;
          }
          pidStr += "_" + bundlePaid;
          orderItem.bundle_items.push({
            cid: items.cid,
            pid: items.pid,
            id:items.id,
            is_bundles: false,
            paid: bundlePaid,
            title: items.abb_title,
            num: items.num,
            unit_price: items.unit_price,
            scribing_price: items.scribing_price,
            status: 1,
            attr1: bundle.attr.color.item[items.attr1],
            attr2: bundle.attr_special.length==0?this.sizeItem[items.sizeNum].title:bundle.attr_special.list? bundle.attr.size.item[bundle.attr_special.list[items.sizeNum]]:bundle.attr_special.only? bundle.attr.size.item[bundle.attr_special.only]:'',
            img: bundle.img.all[0],
            child_id: this.child_id,
            abb_title: items.abb_title,
            quantity: items.num,
            is_bundle_item: true,
            original_key: pidStr,
          });
        }
        orderItem.original_key = pidStr;
      }
      shop.order = [];
      shop.order.push(orderItem);
      storage.set(UNIFORM_SHOPPING + "_" + this.childData.family_id, shop);
      this.$router.push({
        name: "UniformConfirm",
      });
      // creatOrder({ product })
      //   .then((order) => {
      //     if (order.code == 0) {
      //       JSAPIPa({ order_id: order.data.order_id, invoice_id: order.data.invoice_id, child_id: this.child_id })
      //         .then((res) => {
      //           let that = this;
      //           wx.config({
      //             // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //             appId: res.data.jsapiParams.appId,
      //             jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
      //           });
      //           wx.ready(function () {
      //             wx.chooseWXPay({
      //               appId: res.data.jsapiParams.appId, //公众号ID，由商户传入
      //               timestamp: res.data.jsapiParams.timeStamp, //时间戳，自1970年以来的秒数
      //               nonceStr: res.data.jsapiParams.nonceStr, //随机串
      //               package: res.data.jsapiParams.package,
      //               signType: res.data.jsapiParams.signType, //微信签名方式：
      //               paySign: res.data.jsapiParams.paySign, //微信签名
      //               success() {
      //                 that.showLoading = false;
      //                 Toast.success(that.$t("uniform.Payment_successful"));
      //                 that.$router.push({
      //                   name: "UnifromOrder",
      //                 });
      //                 // 支付成功回调
      //               },
      //               cancel() {
      //                 Toast.fail(that.$t("uniform.Cancel_Payment"));
      //                 that.showLoading = false;
      //                 that.getCancelPay(order.data.invoice_id);
      //               },
      //               fail() {
      //                 that.showLoading = false;
      //                 Toast.fail(that.$t("uniform.Payment_Failed"));
      //                 that.getCancelPay(order.data.invoice_id);
      //                 // 支付失败回调
      //               },
      //             });
      //           });
      //         })
      //         .catch(() => {
      //           this.showLoading = false;
      //         });
      //     } else {
      //       this.showLoading = false;
      //       this.currentStock = order.data[0].num;
      //     }
      //   })
      //   .catch(() => {
      //     this.showLoading = false;
      //   });
    },
    getCancelPay(invoice_id) {
      cancelPay({ invoice_ids: invoice_id }).then((invoice) => {
        console.log(invoice);
      });
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #4d88d2;
}

.classify {
  padding: 16px;
  background: #fff;

  .flex1 {
    width: 0;
  }
}

.img88 {
  width: 88px;
  height: 88px;
  border-radius: 8px;
  object-fit: cover;
}

.img72 {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: cover;
}

.uniformList {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin: 12px 16px;
}

.align-items {
  align-items: center;
}

.colorRed {
  color: #ee0a24;
}

.fontWeight {
  font-weight: 500;
}

.word-break {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shopping {
  width: 40px;
  height: 40px;
  background: #4d88d2;
  border-radius: 50%;
  position: fixed;
  right: 16px;
  bottom: 100px;
  line-height: 44px;
  text-align: center;

  .num {
    width: 16px;
    height: 16px;
    background: #ee0a24;
    display: inline-block;
    line-height: 15px;
    position: absolute;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    top: -3px;
  }
}

.word-break2 {
  overflow: hidden; //超出文本隐藏
  text-overflow: ellipsis; ///超出部分省略号显示
  display: -webkit-box; //弹性盒模型
  -webkit-box-orient: vertical; //上下垂直
  -webkit-line-clamp: 2; //自定义行数
  line-clamp: 2;
}

.content {
  padding: 16px;
  padding-bottom: 200px;
  background: #ffffff;

  .categoryTitle {
    color: #323233;
    font-size: 14px;
    font-weight: 500;
    margin: 20px 0 12px 0;
  }

  .tagList {
    color: #323233;
    font-size: 13px;
    padding: 7px 16px;
    background: #f7f8fa;
    border-radius: 4px;
    margin-bottom: 8px;
    margin-right: 10px;
    display: inline-block;
    position: relative;
    border: 1px solid transparent;

    .NoStock {
      right: -10px;
      bottom: 25px;
      background: #ee0a24;
      display: inline-block;
      line-height: 4vw;
      position: absolute;
      border-radius: 50px;
      color: #fff;
      font-size: 3.2vw;
      display: inline-block;
      padding: 2px 4px;
      z-index: 99;
    }
    .presale {
      right: -10px;
      bottom: 25px;
      background: #5cb85c;
      display: inline-block;
      line-height: 4vw;
      position: absolute;
      border-radius: 50px;
      color: #fff;
      font-size: 3.2vw;
      display: inline-block;
      padding: 2px 4px;
      z-index: 99;
    }
  }
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.van-swipe-item img {
  width: 100% !important;
}

.currentTag {
  background: rgba(77, 136, 210, 0.1) !important;
  color: #4d88d2 !important;
  font-weight: 500;
  border: 1px solid #4d88d2 !important;
}

.disabledTag {
  // background:#f2f3f5 !important;
  color: #999 !important;
}

.p10 {
  padding: 10px;
}

.van-stepper__input {
  pointer-events: none;
}

.uniform {
  overflow-y: scroll;
  height: 100vh;
}

.uniform::-webkit-scrollbar {
  display: none;
}

.fontWeight {
  font-weight: 500;
}

.suitLabel {
  padding: 6px 8px;
  background: #f7f8fa;
  border-radius: 4px;
}

.colorWarning {
  color: #ed6a0c;
}
.mt-4 {
  margin-top: 4px;
}
.bundleTag {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background: rgba(0, 0, 0, 0.5);
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  padding: 0 6px;
  border-radius: 12px;
}
.custom-indicator {
  position: absolute;
  right: 16px;
  bottom: 16px;
  padding: 0 6px;
  color: #ffffff;
  line-height: 18px;
  font-size: 12px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.5);
}
.noticeBto {
  color: rgb(102, 102, 102);
  background: rgb(242, 243, 245);
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 70px;
}
</style>
